import LedgerJwtQuery from 'graphs/queries/LedgerJwt.graphql'
import client from 'config/apollo/client'
import ledgerClient from 'config/apollo/ledgerClient'

const loadJwt = () =>
  client
    .query({ query: LedgerJwtQuery, fetchPolicy: 'network-only' })
    .then(result => result.data.ledger_token)

const mutate = (options = {}) =>
  loadJwt().then(token =>
    ledgerClient.mutate({
      ...options,
      context: { headers: { Authorization: `Bearer ${token}` } }
    })
  )

const Ledger = ({ children }) => children({ mutate })

export default Ledger



// WEBPACK FOOTER //
// ./src/components/LedgerClient/index.js